export default "/institutions/google-wallet.svg";